// utils/Axios.js
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';

export const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
  });
  
  instance.interceptors.request.use(
    (config) => {
      const tokenStr = sessionStorage.getItem('kt-auth-react-v');
      let apiToken = null;
      
      if (tokenStr) {
        try {
          apiToken = JSON.parse(tokenStr)['api_token'];
        } catch (e) {
          apiToken = tokenStr;
        }
      }
      
      if (apiToken) {
        config.headers['Authorization'] = `Bearer ${apiToken}`;
      }
      config.headers['x-platform'] = 'irp';
      
      if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
  sessionStorage.removeItem('kt-auth-react-v');
  sessionStorage.removeItem('kt-user-data');
  window.dispatchEvent(new Event('kt-auth-changed'));
  window.location.href = '/login';
}
      return Promise.reject(error);
    }
  );

  return instance;
};

const axiosInstance =createAxiosInstance();
// Login API call
export const loginUser = async (credentials) => {
  try {
    const response = await axiosInstance.post('/auth/login', credentials);
    return response;
  } catch (error) {
    throw error;
  }
};

// Logout API call
export const logoutUser = async () => {
  try {
    const response = await axiosInstance.post('/auth/logout');
    sessionStorage.removeItem('kt-auth-react-v');
    sessionStorage.removeItem('kt-user-data');
    return response;
  } catch (error) {
    // Even if API fails, clear local storage
    sessionStorage.removeItem('kt-auth-react-v');
    sessionStorage.removeItem('kt-user-data');
    throw error;
  }
};

// // Get current user
// export const getCurrentUser = async () => {
//   try {
//     const response = await axiosInstance.get('/auth/me');
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

// Remove old token handling functions
export function receiveTokenFromHash() {
  // This is now handled by the login flow
  return null;
}

export function requestTokenFromMain() {
  // This is now handled by the login flow
  return null;
}